var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinsSwap01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 8.0013L10.6665 5.33464M10.6665 5.33464L7.99984 2.66797M10.6665 5.33464H7.99984C5.05432 5.33464 2.6665 7.72245 2.6665 10.668M23.9998 24.0013L21.3332 26.668M21.3332 26.668L23.9998 29.3346M21.3332 26.668H23.9998C26.9454 26.668 29.3332 24.2802 29.3332 21.3346M17.8894 17.8909C18.9324 18.389 20.1002 18.668 21.3332 18.668C25.7515 18.668 29.3332 15.0862 29.3332 10.668C29.3332 6.24969 25.7515 2.66797 21.3332 2.66797C16.9149 2.66797 13.3332 6.24969 13.3332 10.668C13.3332 11.9009 13.6121 13.0687 14.1103 14.1117M18.6665 21.3346C18.6665 25.7529 15.0848 29.3346 10.6665 29.3346C6.24823 29.3346 2.6665 25.7529 2.6665 21.3346C2.6665 16.9164 6.24823 13.3346 10.6665 13.3346C15.0848 13.3346 18.6665 16.9164 18.6665 21.3346Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsSwap01);
export default __webpack_public_path__ + "static/media/coins-swap-01.3c715994d5001edba9270516ddc9d462.svg";
export { ForwardRef as ReactComponent };